import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable } from 'rxjs/Observable';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Router } from '@angular/router';
import { SERVER, LOGON_INFO, AppConstants, MENU_ROLE } from '../app.constants';
import { CommonService } from '../app.service';


@Injectable()
export class AuthService {

    _jwtHelper: any;

    // store the URL so we can redirect after logging in
    redirectUrl: string;
    

    constructor(
        private _htc: HttpClient,
        private router: Router,
        private commonService: CommonService
    ) {
        this._jwtHelper = new JwtHelperService();
    }
    

    login(id:string, password:string): Observable<boolean> {
        return this._htc.post(SERVER.baseIP+'/jwt-auth/', JSON.stringify({"userid":id, "password":password}))
            .map(response => {
                // レスポンスからjwtのtokenを取得
                //const token = response.json() && response.json().token;  //angular4以前の書き方
                const token = response['token'];                           //angular5以後の書き方

                if(token) {
                    //set the token property for validate token in the app.
                    //this._token = token;
                    sessionStorage.setItem("token", token);
                    sessionStorage.setItem("file_download_token", response["file_download_token"]);

                    sessionStorage.setItem("logon_user_id"       , id);
                    sessionStorage.setItem("logon_user_name"     , response['user']['name']);
                    sessionStorage.setItem("logon_user_div"      , response['user']['div']);
                    sessionStorage.setItem("logon_comp_id"       , response['user']['comp_id']);
                    sessionStorage.setItem("logon_comp_type"     , response['user']['comp_type']);
                    sessionStorage.setItem("logon_parent_comp_id", response['user']['parent_comp_id']);
                    sessionStorage.setItem("logon_menu_role"     , response['user']['menu_type'] == "0" ? MENU_ROLE.MANAGER : MENU_ROLE.NORMAL);

                    //202304 GoogleMap使用しない
                    // sessionStorage.setItem("logon_comp_lat"      , response['user']['comp_id']=="C00000" ? response['user']['address_lat'] : response['user']['comp_lat']);
                    // sessionStorage.setItem("logon_comp_lng"      , response['user']['comp_id']=="C00000" ? response['user']['address_lng'] : response['user']['comp_lng']);
                    sessionStorage.setItem("logon_comp_lat"      , '40.473247')
                    sessionStorage.setItem("logon_comp_lat"      , '141.457254')

                    //202304 ドライバーにアカウント付与しない
                    // sessionStorage.setItem("logon_car_id"        , response['user']['car_info'].length==0 ? "" : response['user']['car_info'][0]['id']);
                    sessionStorage.setItem("logon_car_id"        , '');

                    return true;
                }
                else {
                    return false;
                }
        });
    }


    isAuthenticated(): boolean {
        // Check whether the token is expired and return true or false
        return !this._jwtHelper.isTokenExpired(LOGON_INFO.TOKEN);
    }


    jwtRefreshCheck() {
        const token = LOGON_INFO.TOKEN;
        const expireDate = this._jwtHelper.getTokenExpirationDate(token);
        const nowDate = new Date();
        const diff = expireDate.getTime() - nowDate.getTime();

        //console.log(expireDate.getTime() + " , " + nowDate.getTime() + " , " + (expireDate.getTime()-nowDate.getTime())/1000);

        //jwt有効期限の残り時間が30分以内の場合
        if (Math.floor(diff / 1000) < (60 * 30)) {
            //tokenを再発行してもらう
            console.log("token refresh");
            this.jwtRefresh(token).subscribe();
        }
    }

    
    jwtRefresh(token: string): Observable<boolean> {
        return this._htc.post(SERVER.baseIP+'/jwt-refresh/', JSON.stringify({"token":token}))
            .map(response => {
                let token = response['token'];
                if (token) {
                    sessionStorage.setItem("token", token);
                    return true;
                } else {
                    return false;
                }
            });
    }    

}


export class AuthUser {
    user_id: string;
    user_div: string;
    comp_id: string;
    comp_lat: string;
    comp_lng: string;
    token: string;
}



// WEBPACK FOOTER //
// ./src/app/login/auth.service.ts